export const environment = {
  production: true,
  apiUrl: 'https://portal.billrothhospitals.com/billroth-portal-api/public/',
  // apiUrl: 'http://php8.local/patient-portal/billroth-portal-api/public/',
  country_code: '+91',
  mobile_no: 10,
  ENABLE_APPOINTMENT_PREPAY: false,
  enable_location: [90,91],
  location_id:91,
  location_code: 'BH',
  session_idle: 1300,
  session_timeout: 30,
  privacy_policy: '',
  consent_policy: '',
  consent_to: 'Billroth Hospital',
  customer_care: '',
  hjId: 2975023,
};
